import {Col, Popover, Row} from "antd";
import React, {ReactElement, useMemo} from "react";
import {formatMoney} from "@lib/format";
import {Issue} from "@mwServices/Issue";
import {KeyIcon} from "@components/icons/Icons";
import {DownOutlined, RightOutlined} from "@ant-design/icons";

interface KeyIssueAccordionProps {
    keyInfo: string;
    defaultExpanded: boolean;
    title?: string;
}

const KeyIssueAccordion = ({keyInfo, defaultExpanded, title}: KeyIssueAccordionProps) => {
    const [showKeyInfo, setShowKeyInfo] = React.useState(!!defaultExpanded);

    return (<>
        {keyInfo && (
            <div className={"key-notes-info"}>
                <Row className={"key-notes-title"} onClick={() => setShowKeyInfo(!showKeyInfo)}>
                    <Col span={3} className="text-column">
                        <KeyIcon/>
                    </Col>
                    <Col span={1} className="text-column" style={{maxWidth: 3}}>
                        <div className="right-line"/>
                    </Col>
                    <Col span={19} className="text-column">
                        <div className="pad-10"> {title ? title : "Notable Information"}</div>
                    </Col>
                    <Col span={1} className="text-column">
                        {showKeyInfo ? <DownOutlined/> : <RightOutlined/>}
                    </Col>
                </Row>
                {showKeyInfo && (
                    <Row className="key-notes-text">
                        <Col span={24}>
                            <div className="key-notes-row">{keyInfo}</div>
                        </Col>
                    </Row>
                )}
            </div>
        )}
    </>);
}

export default KeyIssueAccordion;